// Actions
export const SAVE_CANDIDATE_SLUG = 'company/candidateList/lastViewedCandidate/SAVE_CANDIDATE_SLUG'
export const RESET_CANDIDATE_SLUG = 'company/candidateList/lastViewedCandidate/RESET_CANDIDATE_SLUG'

// Action Creators
export const saveCandidateSlug = slug => ({
  type: SAVE_CANDIDATE_SLUG,
  payload: { slug },
})

export const resetCandidateSlug = () => ({
  type: RESET_CANDIDATE_SLUG,
})

// Reducers
const defaultState = {
  slug: '',
}

const lastViewedCandidate = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SAVE_CANDIDATE_SLUG:
      return {
        ...state,
        ...payload,
      }

    case RESET_CANDIDATE_SLUG:
      return defaultState

    default:
      return state
  }
}

export default lastViewedCandidate
